import { render, staticRenderFns } from "./BeforeAfter.vue?vue&type=template&id=2d1947aa&scoped=true"
import script from "./BeforeAfter.vue?vue&type=script&lang=js"
export * from "./BeforeAfter.vue?vue&type=script&lang=js"
import style0 from "./BeforeAfter.vue?vue&type=style&index=0&id=2d1947aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1947aa",
  null
  
)

export default component.exports